export const UPDATE_LIFE_INS_DETAIL = 'UPDATE_LIFE_INS_DETAIL';

export const updateLifeInsDetail = (payload) => {
    return {
        type: UPDATE_LIFE_INS_DETAIL,
        payload
    };
}
